import dayjs from 'dayjs';

export default {
    props: {
        plateBasicInfo: {
            type: Object,
            default: () => { },
        },
        plateStatus: {
            type: Object,
            default: () => { },
        },
        plateDyna: {
            type: Object,
            default: () => { },
        },
        plateStatistics: {
            type: Object,
            default: () => { },
        },
        showSearchIcon: {
            type: Boolean,
            default: () => true,
        }
    },
    data() {
        return {
            showInfo: true,
        };
    },
    computed: {
        price() {
            if (this.plateDyna.LastPrice) return this.plateDyna.LastPrice.toFixed(2);
            return '--';
        },
        updownRate() {
            return this.plateDyna.Updown || this.plateDyna.Updown === 0 ? (this.plateDyna.Updown * 100).toFixed(2) + '%' : '--';
        },
        time() {
            return this.plateDyna.Time ? dayjs(this.plateDyna.Time * 1000).format('YYYY-MM-DD HH:mm') : '--';
        },
    },
    mounted() {
        this.addScrollListener();
    },
    filters: {
        getStatus(type) {
            const PLATE_STATUS = {
                1: '无效状态',
                2: '开市状态',
                3: '交易中',
                4: '已收盘',
                5: '休市',
            };
            return type ? PLATE_STATUS[type] : '--';
        },
        subStr(val) {
            if (!val) return '--';
            if (val && val.length > 10) return `${val.substring(0, 10)}...`;
            return val;
        },
    },
    methods: {
        handleScroll() {
            let _this = this;
            let timer = null;
            return function (e) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    _this.showInfo = window.scrollY === 0;
                }, 300);
            };
        },
        addScrollListener() {
            document.addEventListener('scroll', this.handleScroll());
        },
    },
};
